import { observer } from "mobx-react-lite";
import axios from "axios";
import React, { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import { Button } from "semantic-ui-react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Pagination from "react-bootstrap/Pagination";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useStore } from "../../../app/stores/store";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ModalMatricularEstudiante from "../../Convenios/Handlers/ModalMatricularEstudiante";
import ModalMatricularMasiva from "../../Convenios/Handlers/ModalMatricularMasiva";
import ModalDesmatricular from "../handlers/ModalConvenioDesmatricular"

const apiURL = process.env.REACT_APP_API_URL;
let paginadorTotal: number;

const modTool = ( p: any ) => (
    <Tooltip id="button-tooltip" { ...p }>
        Desmatricular estudiante
    </Tooltip>
);

interface Props{
    id:string,
    codigoInstitucional: string
}

export default observer(function ListEstudiantesXConvenio( props: Props ) {

    let items: any = [];
    const [modalShow, setModalShow] = useState(false);
    const [modalShowMa, setModalShowMa] = useState(false);
    const [modalShowMm, setModalShowMm] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [estudiantes, setEstudiantes] = useState([]);

    const [updateCounter, setUpdateCounter] = useState(0);

    const updateStudentList = () => {
        setModalShow(false);
        setUpdateCounter(updateCounter + 1);
        liStudents();
      };

    const [loading, setLoading] = useState(false);
    const handlePageClick = (numberPagina: number) => { setCurrentPage(numberPagina) };
    const urlp = apiURL + `/CATConvenios/EnrollByAgreements/${props.id}/${currentPage}/10/`;

    const [student, setStudent] =
        useState({
            studentKey: 0,
            nombres: "",
            appUserId: "",
            apellidos: "",
            edicionId: 0,
            dpi: 0
        });

    const {
        studentKey,
        nombres,
        appUserId,
        edicionId,
        apellidos,
        dpi,
    } = student;


    const liStudents = async () => {
        const responseConvenio = await axios(urlp);
        const { data } = responseConvenio;
        paginadorTotal = data.totalPages;

        const estudiantes = data.records.map(
            (dataR: {
                studentKey: number;
                nombres: string;
                apellidos: any;
                appUserId: any;
                edicionId: number;
                dpi: number;
                grade: number;
            }) => {
                return {
                    studentKey: dataR.dpi,
                    nombres: dataR.nombres,
                    apellidos: dataR.apellidos,
                    appUserId: dataR.appUserId,
                    edicionId: dataR.edicionId,
                    dpi: dataR.dpi,
                    grade: dataR.grade
                };
            }
        );
        //console.log("ver data 2", data)

        setEstudiantes(estudiantes);
        setLoading(false);
    }; useEffect(() => { liStudents() }, [currentPage]);


    for (
        let numberPagina: number = 1;
        numberPagina <= paginadorTotal;
        numberPagina++
    ) {
        items.push(
            <Pagination.Item
                key={studentKey}
                active={currentPage === numberPagina}
                activeLabel={""}
                onClick={() => {
                    handlePageClick(numberPagina);
                }}
            >
                {numberPagina}
            </Pagination.Item>
        );
    }

    function pmod(
        key: number,
        nombres: string,
        apellidos: string,
        appUserId: string,
        edicionId: number,        
        dpi: number

    ) {
        setStudent({
            ...student,
            studentKey: dpi,
            dpi: dpi,
            nombres: nombres,
            apellidos: apellidos,
            appUserId: appUserId,
            edicionId: edicionId
        });
        setModalShow(true);
    }

    const StudentsItems = (dataR: {
        studentKey: number;
        nombres: string;
        apellidos: any;
        appUserId: string;
        edicionId: any;
        dpi: number;
        grade: number;

    }) => {

        return (

            <Row className="solicitudes-list students-list" key={dataR.studentKey}>
                <Col xs={3} className="solicitud-body-sec">{dataR.nombres}</Col>
                <Col xs={3} className="solicitud-body-sec">{dataR.apellidos}</Col>
                <Col xs={3} className="solicitud-body-sec ccentrada">{dataR.dpi}</Col>
                <Col xs={1} className="solicitud-body-sec ccentrada">{dataR.grade}</Col>
                <Col xs={2} className="solicitud-body-sec-actions ccentrada">{

                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={modTool}
                    >

                        <Button
                            className="circular-button edi-sol-but"
                            circular
                            color='red'
                            type="button"
                            icon={'trash alternate'}
                            onClick={() => pmod(
                                dataR.studentKey,
                                dataR.nombres,                                
                                dataR.apellidos,
                                dataR.appUserId,
                                dataR.edicionId,
                                dataR.dpi
                            )}
                        />

                    </OverlayTrigger>

                }
                </Col>
            </Row>

        );
    };

    return (

        <div key={updateCounter}>

            <Container className="convenios-section interior-solicitudes">

                <Container>
                    <Row className="buttons-op-conv-area">
                        <Col xs={7} className="buscar-convenio-area">
                            <Form.Control placeholder="Buscar estudiante" />
                            <Button blue className="button-blue-c" >Buscar</Button>{" "}
                        </Col>


                        <Col xs={5}>
                            {/* <Button variant="primary" onClick={() => setModalShowMa(true)}>Matricular estudiante</Button>{" "} */}
                            <Button green className="button-green-c" onClick={() => setModalShowMm(true)}>Matriculación masiva</Button>{" "}
                        </Col>
                    </Row>
                </Container>

                <Container className="convenio-body-list solicitudes-body-area">
                    {loading ? (

                        <LoadingComponent content="Cargando códigos..." key={Math.random()} />

                    ) : (

                        estudiantes.length ?(
                                 <>

                                        <Container className="convenio-head-list">
                                            <Col xs={3} className="convenio-head-section">Nombres</Col>
                                            <Col xs={3} className="convenio-head-section">Apellidos</Col>
                                            <Col xs={3} className="convenio-head-section ccentrada">DPI</Col>
                                            <Col xs={1} className="convenio-head-section ccentrada">Nota</Col>
                                            <Col xs={2} className="convenio-head-section ccentrada">Acciones</Col>
                                        </Container>

                            {estudiantes.map((ST: {
                                    studentKey: number;
                                    nombres: string;
                                    apellidos: string;
                                    appUserId: any;
                                    dpi: number;
                                    grade: number;
                                    edicionId: number;
                                }) => (        

                                        <StudentsItems {...ST} />
                                )) }

                                    </>


                                
                            ) : (<p className="list-notice">Este código aún no cuenta con estudiantes inscritos, <br />por favor indícales a los participantes que se inscriban al servicio del código establecido.</p>

))}  
                </Container>

                <Container className="pagination-convenios-area">
                    <Pagination>{items}</Pagination>
                </Container>

            </Container>

            <ModalDesmatricular
                onHide={() => { setModalShow(false) }}
                show={modalShow}
                key={studentKey}
                appUserId={appUserId}
                nombres={nombres}
                catEdicionesId={edicionId}
                apellidos={apellidos}
                dpi={dpi}
                codigoInstitucional={props.codigoInstitucional}
                updateStudentList={updateStudentList}
            />

            <ModalMatricularEstudiante
                onHide={() => { setModalShowMa(false) }}
                show={modalShowMa}
                key={studentKey}
                conv={""}
                convref={""}
            />

            <ModalMatricularMasiva
                onHide={() => { setModalShowMm(false) }}
                show={modalShowMm}
                key={studentKey}
                conv={""}
                convref={""}
            />

            {/* 
            <ReporteInscritosXConvenio
                onHide={ ()=> { setModalShow(false)}}
                show={modalShow}
                id={idsol}
                convno={noconv}
            /> */}

        </div>

    )
});